import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { OrderedJoinServiceBase } from '../../shared/base/ordered-join-service-base';

@Injectable()
export class LectureCommentService extends OrderedJoinServiceBase {
  constructor(db: AngularFireDatabase) {
    super(db, '/lecture-comments', '/comments');
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture-comment.service.ts